import * as React from 'react';
export const MESvg = React.forwardRef(function MESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.5 2.5H14A1.5 1.5 0 0 1 15.5 4v8a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 12V4A1.5 1.5 0 0 1 2 2.5h.5Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.8 5c0 1.95 1.6 2.9 3.2 2.9 1.6-.02 3.2-1 3.2-2.9 2.03 2.57-.06 5.79-3.2 5.81-3.17.02-5.23-3.23-3.2-5.81Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('circle', {
      cx: 8,
      cy: 5,
      r: 1,
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('circle', {
      cx: 8,
      cy: 11,
      r: 1,
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('circle', {
      cx: 8,
      cy: 9,
      r: 1,
      fill: '#24B47E',
    }),
    /*#__PURE__*/ React.createElement('circle', {
      cx: 8,
      cy: 8,
      r: 1,
      fill: '#43458B',
    }),
  );
});
MESvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ME = {
  category: 'flag',
  colorable: false,
  name: 'ME',
  svg: MESvg,
};
